import React, { useContext, useEffect } from "react";
import { Form, Input, Button, Card, Image, notification } from "antd";
import AuthenticationContext from "../../contexts/auth/AuthenticationContext";
import { ContextStatus } from '@leedpulse-monorepo/enums';

import { LeedflowLogoLight as logo } from '@leedpulse-monorepo/assets';

const SignInForm: React.FC = () => {
  const authContext = useContext(AuthenticationContext);

  const onFinish = (values: any) => {
    authContext.submitSignIn(values.email, values.password);
  };

  useEffect(() => {
    if (authContext.status === ContextStatus.ERROR) {
      notification.error({
        message: "Erreur",
        description: "Vérifiez vos informations de connexion.",
      });
    }
  }, [authContext.status]);

  return (
    <Card
      style={{
        width: "100%",
        maxWidth: 376,
      }}
    >
      <Image
        src={logo}
        alt="Logo"
        preview={false}
        style={{
          marginTop: "1rem",
          marginBottom: "1.5rem",
          padding: "0.75rem 1.5rem",
        }}
      />
      <Form
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        requiredMark={false}
      >
        <Form.Item
          label="Email :"
          name="email"
          rules={[
            { required: true, message: "L'adresse email est obligatoire." },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Mot de passe :"
          name="password"
          rules={[
            { required: true, message: "Le mot de passe est obligatoire." },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          style={{
            marginBottom: "1rem",
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            className="fluid"
            style={{
              marginTop: "1rem",
              width: "100%",
            }}
            loading={authContext.status === ContextStatus.LOADING}
            disabled={authContext.status === ContextStatus.LOADING}
          >
            Se connecter
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default SignInForm;
